const FDS_LOGIN_URL = 'https://fds.qiweihu.cn/login_by_token'

export const getFDSTokenFromResponse = (response) => {
    const body = response && response.data ? response.data : {}
    const data = body.data

    if (typeof data === 'string') {
        return data
    }

    if (data && typeof data === 'object') {
        return data.token || data.access_token || data.accessToken || ''
    }

    return body.token || body.access_token || body.accessToken || ''
}

export const buildFDSLoginUrl = (token) => {
    return `${FDS_LOGIN_URL}?access_token=${encodeURIComponent(token)}`
}
